exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".carousel[data-v-6e59c9b5]{height:200px}.carousel .el-carousel[data-v-6e59c9b5]{height:100%}.carousel .el-carousel .el-carousel__item .img[data-v-6e59c9b5]{width:100%;height:100%;-o-object-fit:cover;object-fit:cover}.carousel[data-v-6e59c9b5]  .el-carousel__container{height:100%}", ""]);

// exports
